export type BrowserApiConfig = {
  apiBaseUrl: string;
  superTokensApiUrl: string;
  tenantId: string;
};

const KEY = '__B2B_BROWSER_API_CONFIG__';

const getStore = (): BrowserApiConfig => {
  const g = globalThis as unknown as Record<string, unknown>;
  if (!g[KEY]) {
    g[KEY] = {
      apiBaseUrl: '',
      superTokensApiUrl: '',
      tenantId: '',
    } satisfies BrowserApiConfig;
  }
  return g[KEY] as BrowserApiConfig;
};

export const isBrowser = () => typeof window !== 'undefined';

export const getBrowserApiConfig = (): BrowserApiConfig => {
  return getStore();
};

export const setBrowserApiConfig = (
  apiBaseUrl: string,
  superTokensApiUrl: string,
  tenantId: string,
) => {
  if (!isBrowser()) return;

  const store = getStore();
  store.apiBaseUrl = apiBaseUrl;
  store.superTokensApiUrl = superTokensApiUrl;
  store.tenantId = tenantId;
};
